import React, { useState } from 'react';
import { form1 } from "../Service/Api";
import { getHeader } from "../config"; 

 
const FooterMail = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
      name: "",
      email: "",
      message: "",
      phone: "",
      school: "FARRUKHABAD",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => { 
          setFormData({
              ...formData,
              [e.target.name]: e.target.value
          });
          setErrors({ ...errors, [e.target.name]: "" }); // Clear the error for the field being changed
      
  };

  const validateForm = () => {
      const newErrors = {};
      if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.email) {
    newErrors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = "Email is invalid";
  }
  if (!formData.phone) {
    newErrors.phone = "Phone number is required";
  } else if (!/^\d{10}$/.test(formData.phone)) {
    newErrors.phone = "Phone number must be 10 digits";
  }
      if (!formData.message) newErrors.message = "Message is required."; 
      
     
      return newErrors;
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      const validationErrors = validateForm();
      if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
          return;
      }

      const type = 'Get In Touch'; 
      console.log('Submitting form with type:', type); // Debugging line

      
     
     
      try {
          const { header } = getHeader(); // Make sure this function returns the correct headers
          const response = await form1(formData, header, type); 
          console.log('Form submitted successfully', response);
          setSuccessMessage("Your Form Submitted Successfully.");
          setFormData({
              name: "",
      email: "",
      message: "",
      phone: "",
      school: "",
          });
      } catch (error) {
          console.error('Error submitting form:', error);
      }
  };

  return (
    <div>
     
        <form onSubmit={handleSubmit}>
          <div className="w-50">
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            {errors.name && <p className="error">{errors.name}</p>}
          </div>
          <div className="w-50">
            <label>Contact</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
          <div className="w-100">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </div>
          <div className="w-100">
            <label>Message</label>
            <textarea
              rows="1"
              cols="30"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            {errors.message && <p className="error">{errors.message}</p>}
          </div>
          <div className="w-100">
            <input type="submit" value="SUBMIT" />
          </div>
          <div className="row primarydiv"> 
          <div className="col-lg-12 col-md-12">
          {successMessage && <div className='primary-alert'>{successMessage}</div>} 
          </div>
      </div>
        </form>
      
    </div>
  );
};

export default FooterMail;
